import { useEffect } from "react";

const DEFAULT_BRAND = {
  primary: "#5e35b1",
  primaryLight: "#ede7f6",
  secondary: "#ff6f00",
};

/**
 * Apply org branding as CSS variables for shared training plan views.
 */
export function useTrainingPlanTheme(brandingColors) {
  useEffect(() => {
    const branding = brandingColors ?? DEFAULT_BRAND;
    const root = document.documentElement;
    root.style.setProperty("--pp-primary", branding.primary || DEFAULT_BRAND.primary);
    root.style.setProperty(
      "--pp-primary-light",
      branding.primaryLight || DEFAULT_BRAND.primaryLight
    );
    root.style.setProperty("--pp-secondary", branding.secondary || DEFAULT_BRAND.secondary);
  }, [brandingColors]);
}
